import { SelectGroup, SelectItem, SelectLabel } from '@roger/ui-components';

import type { RelatedManifests } from '../../reporting/columnRefs';
import type { DatasetManifestEntry } from '../../types/reporting';

export interface ColumnOption {
  ref: string;
  label: string;
}

export interface OptionGroup {
  key: string; // '' for the primary dataset
  label: string | null; // null = primary (no heading)
  options: ColumnOption[];
}

// Primary columns first (no heading, matching today's flat list), then one
// labeled group per related dataset. `keep` filters refs (e.g. exclude columns
// already used by another group-by).
export function optionGroups(
  dataset: DatasetManifestEntry,
  related: RelatedManifests,
  keep: (ref: string) => boolean = () => true
): OptionGroup[] {
  const groups: OptionGroup[] = [
    {
      key: '',
      label: null,
      options: dataset.columns
        .filter(c => keep(c.name))
        .map(c => ({ ref: c.name, label: c.label })),
    },
    ...[...related.entries()].map(([key, entry]) => ({
      key,
      label: entry.label,
      options: entry.columns
        .filter(c => keep(`${key}.${c.name}`))
        .map(c => ({ ref: `${key}.${c.name}`, label: c.label })),
    })),
  ];
  return groups.filter(g => g.options.length > 0);
}

export function renderOptionGroups(groups: OptionGroup[]) {
  return groups.map(group =>
    group.label === null ? (
      group.options.map(option => (
        <SelectItem key={option.ref} value={option.ref}>
          {option.label}
        </SelectItem>
      ))
    ) : (
      <SelectGroup key={group.key}>
        <SelectLabel>{group.label}</SelectLabel>
        {group.options.map(option => (
          <SelectItem key={option.ref} value={option.ref}>
            {option.label}
          </SelectItem>
        ))}
      </SelectGroup>
    )
  );
}
